var $ = require('lc-jquery');

function handlePopovers(event) {
  var target = $(event.target).closest('[data-popover-target]');
  var popover_target = target.data('popover-target');
  var show = event.type === 'mouseover' || event.type === 'focusin';
  target.parent().find('[data-popover-id=' + popover_target + ']').toggleClass('in', show);
}

$('[data-popover-target]').on('mouseover mouseout focusin focusout', handlePopovers);



var dependencies = {
  common: require('./common.css'),
  sprites: require('sprites'),
  header: require('header'),
  footer: require('footer'),
  liveperson: require('liveperson')
};

function setHeight() {
  var windowHeight = $(window).innerHeight() - 224; // length of header+footer
  $('.main-content').css('min-height', windowHeight);
}

// Only need to do for Safari because of vh. Other browsers take care of this.
if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0) {
  setHeight();
  $(window).resize(function() {
    setHeight();
  });
}

// Exporting dependencies for testing
module.exports = dependencies;

require('/var/lib/jenkins/workspace/pf-onboarding-ui_Release_0/src/node_modules/base-layout/base-layout.less');
require('/var/lib/jenkins/workspace/pf-onboarding-ui_Release_0/src/node_modules/base-layout/img/favicon.ico');